import script from "./DocumentAdministration.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentAdministration.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentAdministration.vue?vue&type=style&index=0&id=69d7775c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d7775c"]])

export default __exports__